export const notepad = {
    rolesCanShowBannerInfo: ['learner', 'trainer']
};
